import axios from "axios";
import { store } from "../../store";

export async function modifyMessageConstantAction() {
  const token =
    sessionStorage.getItem("token") ?? localStorage.getItem("token");
  const { validFrom, validTo, id } = store.getState().messageConstant;
  const params = {
    id,
    validFrom,
    validTo,
  };

  return await axios
    .put(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/message-constants`,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data);
}
